// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jWMvmZo5XPLaLv {
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 12px;
  line-height: 20px;
}
.jWMvmZo5XPLaLv a {
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whiteBox": `jWMvmZo5XPLaLv`
};
export default ___CSS_LOADER_EXPORT___;
